<template>
    <div class="map-container">
        <div id="where-we-build-map" class="map"></div>
       
    </div>
</template>

<script>
import { Maps } from "tortilla";
import mapStylesDefault from "../vendor/google-map-snazzymaps";
import { createMap, createMarker, fitMapBounds, createInfoWindow, communityContentPopup } from '../utils/mapUtils';
import { getCommunityMarkerImage, getMarkerImage } from '../helpers/mapHelpers';
import { round } from '../helpers/numberHelpers';
const { MarkerClusterer } = Maps.Markers;

var clusterPopovercontent = function(types) {
    let properties = "";

    for (const property in types) {
        properties += `
      <div class="cluster-map-key__item middle-xs">
          <img src="${getMarkerImage()}">
          <span>(${types[property].total}) ${types[property].title}</span>
      </div>
    `;
    }

    return `
    <div class="cluster-map-key row middle-xs around-xs">
      ${properties}
    </div>
  `;
};

export default {
    props: {
        regionId: false,
        counties: String,
        clustered: {
            type: Boolean,
            default: false
        },
        displayCountyLines: {
            default: true
        },
        isActive: {
            type: Function,
            default: () => true,
        },
        communities: { type: Array, default: () => ([]) }
    },
    data() {
        return {
            gm:  {},
            cities: [],
            mapInstance: {},
            markers: [],
            loaded: false,
            mobileMapToggle: false,
            parameters: {
                region_id: this.regionId
            },
            infoWindow: false,
            markerCluster: false,
            clusterInfoWindow: false,
            mapBoundary: { top: 75, right: 75, bottom: 75, left: 75 }
        };
    },
    computed: {
        mapStyles() {
            return mapStylesDefault;
        }
    },
    watch: {
        cities: function() {
            this.markers.forEach((marker) => marker.map = null);
            this.markers = [];
            this.cities.map(this.cityMarker).filter(a => {
                return a;
            });
            if (this.clustered) {
                this.initClusterer();
            }
        },
        communities: {
            handler: function(val) {
                if (!this.loaded) {
                    return;
                }
                this.markers.forEach((marker) => marker.map = null);
                this.markers = [];
                this.communities.map(this.communityMarker).filter(a => {
                    return a;
                });

                if (this.clustered) {
                    this.initClusterer();
                }
            },
            deep: true
        }
    },
    created() {
       
        events.$on("tab-active", (item) => {
            if (item !== "map") {
                return;
            }

            // this.findCities();
            this.findCommunities();
        });
    
    },

    mounted() {
        const vm = this;
        vm.$nextTick(() => {
            events.$on("map-intialized", (map) => {
                this.initialize(map);
            });
        });
       

        this.$eventsBus.$on("slider-range-updated", $event => {
            this.parameters[$event[0]] = $event[1];
            this.parameters[$event[2]] = $event[3];
            this.citySearch();
        });
        this.$eventsBus.$on("community-over", this.handleCardOver);
        this.$eventsBus.$on("community-out", this.handleCardOut);
        //this.$eventsBus.$on('community-out', this.closeInfoWindows)
    },
    beforeDestroy() {
        this.$eventsBus.$off("slider-range-updated");
        this.$eventsBus.$off("community-over", this.handleCardOver);
        this.$eventsBus.$off("community-out", this.handleCardOut);
        //this.$eventsBus.$off('community-out', this.closeInfoWindows)
    },
    methods: {
        async initialize() {
            try {
                this.gm = google.maps;
                this.mapInstance = await createMap('where-we-build-map');
                this.infoWindow = createInfoWindow();
                this.setMapInstance(this.mapInstance);
                this.setCounties(this.mapInstance);
                this.initListeners();
                this.loaded = true;
                
                
                await Promise.all(this.communities.map(this.communityMarker));
                
                if (this.clustered) {
                    this.initClusterer();
                }
            } catch (error) {
                console.error('Failed to initialize map:', error);
            }
        },
        mapPinIcon(icon) {
            return `/images/site/maps/${icon}-pin.svg`;
        },
        handleCardOver(id) {
            const markerId =  typeof id === 'string' ? id : `marker_${id}`;
            if( typeof id === 'string') this.handleMarkerOver(markerId);
            const marker = this.markers.find(obj => obj.id === markerId);
            const icon = this.mapPinIcon("blue");

            if (window.google != undefined && marker) {
                this.setMarkerIcon(marker, icon);
            }
        },
        handleCardOut(id) {
          
            const markerId =  typeof id === 'string' ? id : `marker_${id}`;
            if( typeof id === 'string') this.handleMarkerOut(markerId);
            const marker = this.markers.find(obj => obj.id === markerId);
            const icon = this.mapPinIcon("white");
            
            if (window.google != undefined && marker) {       
                this.setMarkerIcon(marker, icon);
            }
        },
        setMarkerIcon(marker, icon) {
            const imgElement = marker.content.querySelector('img');
            if (imgElement) {
                imgElement.src = icon;
            } else {
                marker.content.innerHTML = `<img src="${icon}" />`;
            }
        },
        closeInfoWindows: function(id) {
            if (this.infoWindow) {
                this.infoWindow.close();
                const icon = this.mapPinIcon("white");
            }

            if (this.clusterInfoWindow) {
                this.clusterInfoWindow.close();
            }
        },
        setMapInstance(map) {
            this.mapInstance = map;
        },
        setCounties(map) {
            if (!this.displayCountyLines) {
                return;
            }
            if (!google || !google.maps || !google.maps.KmlLayer) {
                console.error('Google Maps KML module not loaded');
                return;
            }

            try {
                const kmlLayer = new google.maps.KmlLayer({
                    url: this.counties,
                    suppressInfoWindows: true,
                    clickable: false,
                    preserveViewport: true,
                    map
                });
            } catch (error) {
                console.error('Error creating KML layer:', error);
            }
        },
        setCities(result) {
            this.cities = result.data;
        },
        cityPopoverContent(city) {
            return Tortilla.Xhr.get(
                `/components/where-we-build-city-popover/${city.id}`,
                this.parameters
            ).then(function(res) {
                return res.data;
            });
        },
        setCities(result) {
            this.cities = result.data;
        },
        // setCommunities: function(result) {
        //     this.communities = result.data;
        //     this.loaded = true;
        // },
        cityPopoverContent(city) {
            return Tortilla.Xhr.get(
                `/components/where-we-build-city-popover/${city.id}`,
                this.parameters
            ).then(function(res) {
                return res.data;
            });
        },
        communityPopoverContent(community) {
            return Tortilla.Xhr.get(
                `/components/where-we-build-community-popover/${community.id}`,
                this.parameters
            ).then(function(res) {
                return res.data;
            });
        },
        communityHoverContent(community) {
            return `<div class="community-card map-community-card">
                <div class="community-card__inner">
                    <p class="community-card__title">${community.name}</p>
                </div>
            </div>`;
        },
        getMarker(latitude, longitude) {
            const lat = round(latitude, 6);
            const lng = round(longitude, 6);

            var res = this.markers.filter(function(m) {
                const mlat = round(m.position.lat(), 6);
                const mlng = round(m.position.lng(), 6);
                return mlat === lat && mlng === lng;
            });

            if (res.length === 1) {
                return res[0];
            }

            return false;
        },
        createInvisibleMarker(lat, lng) {
            var marker = new this.gm.Marker({
                map: this.mapInstance,
                icon: {
                    scaledSize: new this.gm.Size(0, 0)
                },
                optimized: false,
                position: { lat: lat, lng: lng },
                id: `marker_invisible`,
                content: {}
            });

            marker.setVisible(false);

            return marker;
        },
        getInfoWindow() {
            let infoWindow;

            infoWindow = new this.gm.InfoWindow({
                //maxWidth: 249,
                maxWidth: 350
            });

            // need this to add class to parent div of infowindow for styling
            this.gm.event.addListener(infoWindow, "domready", function() {
                if (window.innerWidth <= 991) {
                    const parent = document.querySelector(".gm-style-iw").parentNode;
                    parent.classList.add("custom-iw");
                    parent.lastChild.classList.add("custom-close-iw");
                }
            });
            return infoWindow;
        },
        async communityMarker(community) {
            if (!community.latitude || !community.longitude) return null;

            var marker = await createMarker({
                map: this.mapInstance,
                position: {
                    lat: community.latitude,
                    lng: community.longitude
                },
                icon: '/images/site/maps/white-pin.svg',
                title: community.name,
                className: 'custom-marker',
                id: `marker_${community.id}` 
            });

            marker.addListener('click', this.handleMarkerClick.bind(this, community, marker));
            marker.content.addEventListener('mouseover', this.handleMarkerMouseEnter.bind(this, marker));
            marker.content.addEventListener('mouseout', this.handleMarkerMouseLeave.bind(this, marker));
           
            this.markers.push(marker);
            fitMapBounds(this.mapInstance, this.markers, 13);
            return marker;
        },
        async cityMarker(city) {
            if (!city.latitude || !city.longitude) return null;

            const marker = await createMarker({
                map: this.mapInstance,
                position: {
                    lat: city.latitude,
                    lng: city.longitude
                },
                icon: getCommunityMarkerImage(city),
                size: { width: 58, height: 58 },
                title: city.name,
                className: 'city-marker'
            });

            marker.content.dataset.propertyType = JSON.stringify({
                total: 1,
                key: city.property_type,
                title: city.property_type_title
            });

            return marker;
        },
        // findCommunities: function() {
        //     return Tortilla.Xhr.get("/api/communities", this.parameters).then(
        //         this.setCommunities
        //     );

        //     this.loaded = true;
        // },
        findCities() {
            return Tortilla.Xhr.get("/api/regions", this.parameters).then(
                this.setCities
            );
        },
        citySearch() {
            return Tortilla.Xhr.get(
                "/api/regions/search",
                this.parameters
            ).then(this.setCities);
        },
        initListeners() {
            // this.gm.event.addListener(this.mapInstance, "zoom_changed", () => {
            //     this.closeInfoWindows();
            // });
            this.mapInstance.addListener( "zoom_changed", () => {
                this.closeInfoWindows();
            });
        },
        getMarkerTypes(markers) {
            const types = {};
            markers.forEach(marker => {
                if (!(marker.property_type.key in types)) {
                    types[marker.property_type.key] = {
                        total: marker.property_type.total,
                        title: marker.property_type.title
                    };
                } else {
                    types[marker.property_type.key].total +=
                        marker.property_type.total;
                }
            });

            return types;
        },
        handleMarkerOver(id) {
            this.$eventsBus.$emit("marker-over", id);
        },
        handleMarkerOut(id) {
            this.$eventsBus.$emit("marker-out", id);
        },
        initClusterer() {
            if (this.markerCluster) {
                this.markers.forEach(marker => {
                    marker.content.removeEventListener('mouseover', this.handleMarkerMouseEnter, false);
                    marker.content.removeEventListener('mouseout', this.handleMarkerMouseLeave, false);
                    marker.setMap(null);
                });
                this.markerCluster.clearMarkers();
            }

            this.markerCluster = new MarkerClusterer(this.mapInstance, this.markers, {
                maxZoom: 10,
                minimumClusterSize: 3,
                averageCenter: true,
                styles: [{
                    textSize: 1,
                    url: "/images/site/maps/cluster-map-pin.svg",
                    height: 70,
                    width: 70
                }]
            });

            this.clusterInfoWindow = new google.maps.InfoWindow({
                maxWidth: 400,
                pixelOffset: new google.maps.Size(0, -20)
            });
            fitMapBounds(this.mapInstance, this.markers, 13);
            this.addClustererListeners();
        },
        addClustererListeners() {
            this.gm.event.addListener(
                this.clusterInfoWindow,
                "domready",
                function() {
                    const parent = document.querySelector(".gm-style-iw")
                        .parentNode;
                    parent.classList.add("cluster-custom-iw");
                }
            );

            this.gm.event.addListener(
                this.markerCluster,
                "mouseover",
                cluster => {
                    this.showClusterInfoWindow(cluster);
                }
            );

            this.gm.event.addListener(this.markerCluster, "mouseout", () => {
                this.clusterInfoWindow.close();
            });
        },
        showClusterInfoWindow(cluster) {
            const types = this.getMarkerTypes(cluster.getMarkers());

            this.closeInfoWindows();
            this.clusterInfoWindow.setContent(clusterPopovercontent(types));
            this.clusterInfoWindow.setPosition(cluster.getCenter());
            this.clusterInfoWindow.open(this.mapInstance);
        },
        handleMarkerClick(community, marker) {
            //  your logic here
           
            if (window.innerWidth <= 991) {
                    // reuse the marker at this lat/lng
                    this.communityPopoverContent(community).then(
                        content => {
                            // marker.content = content;
                            // marker.property_type.total += 1;

                            if (this.infoWindow !== false) {
                                this.infoWindow.close();
                                this.infoWindow.setContent(communityContentPopup(community));
                                this.infoWindow.open(
                                    this.mapInstance,
                                    marker
                                );

                                // adjust infowindow width when only one card
                                if (
                                    community && 
                                    community.communities_count && 
                                    community.communities_count.amount &&  
                                    community.communities_count.amount < 2
                                ) {
                                    const parent = document.querySelector(
                                        ".gm-style-iw"
                                    ).parentNode;
                                    parent.classList.add("single-popover");
                                }
                            }
                            return this.markers.push(marker);
                        }
                    );

                    // styling the native arrow. needed to offset the flyout changes
                    $(
                        $(
                            ".gm-style > div:first-child > div + div > div:last-child > div > div:first-child > div > div > div"
                        ).children()[0]
                    ).css({
                        left: "0px",
                        "background-color": "rgb(236, 236, 236)",
                        transform: "skewX(43.6deg)",
                        height: "20px",
                        width: "16px",
                        top: "4px",
                        "box-shadow": "-2px 2px 2px rgba(0, 0, 0, 0.3)"
                    });
                    $(
                        $(
                            ".gm-style > div:first-child > div + div > div:last-child > div > div:first-child > div > div > div"
                        ).children()[1]
                    ).css({
                        left: "0px",
                        "background-color": "rgb(236, 236, 236)",
                        transform: "skewX(-43.6deg)",
                        height: "17px",
                        width: "16px",
                        top: "4px",
                        "box-shadow": "2px 2px 2px rgba(0, 0, 0, 0.3)"
                    });
            } else {
                    this.infoWindow.close();
                    this.infoWindow.setContent(communityContentPopup(community));
                    // this.infoWindow.open(marker.getMap(), marker);
                    this.infoWindow.open(this.mapInstance, marker);
            }
        },
        handleMarkerMouseEnter( marker) {
            this.handleCardOver(marker.id);
        },
        handleMarkerMouseLeave(marker) {
            this.handleCardOut(marker.id);
        }
    }
};
</script>

<style scoped>
.map-container {
    width: 100%;
    height: 100%;
    min-height: 400px;
}
.map {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/components/apps/where-we-build-map.vue